import {useState, useEffect} from 'react';
import dotMenu from '../../../images/dot-menu.svg';
import OutsideAlerter from "../../hooks/OutsideAlerter";
import * as Styled from './DotMenuStyles';

export interface DotMenuStandardProps {
  options: Array<MenuOption>;
  visible?: boolean;
}

export interface MenuOption {
  label: string,
  labelType?: string,
  action: Function,
}

const DotMenu = ({options, visible}:DotMenuStandardProps) => {
  const [isDotsMenuVisible, setDotsMenuVisible] = useState(false);
  const [isDotsVisible, setDotsVisible] = useState(!!visible);
  const toggleDotMenu = (e:any) => {
    e.stopPropagation();
    setDotsMenuVisible(!isDotsMenuVisible);
  }

  const triggerAction = (e:any, action: Function) => {
    e.stopPropagation();
    setDotsMenuVisible(false);
    action(e);
  }

  useEffect(() => {
    setDotsVisible(!!visible);
    if (!visible) {
      setDotsMenuVisible(false);
    }
  }, [visible]);


  if (!isDotsVisible) {
    return null;
  }

  return  (
    <OutsideAlerter setFunction={setDotsMenuVisible}>
      <Styled.Container className="Dots" onClick={toggleDotMenu}>
        <Styled.StyledImg
          src={dotMenu}
          alt="Dot menu"
        />
        <Styled.Container className="MenuFromDots">
          {
            isDotsMenuVisible ?
              <Styled.StyledList>
                {
                  options && options.map(opt =>
                    <MenuItem key={opt.label} item={opt} onClick={triggerAction} />
                  )
                }
              </Styled.StyledList>
              :
              null
          }
        </Styled.Container>
      </Styled.Container>
    </OutsideAlerter>
  );
}

const MenuItem = ({ item, onClick }:any) => {
  const triggerAction = (e:any) => {
    onClick(e, item.action);
  }

  return (
    <Styled.StyledLi
      key={item.label}
      className={item.labelType}
      onClick={triggerAction}
    >
      {item.label}
    </Styled.StyledLi>
  )
}

export default DotMenu;